import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
// import axios from 'axios';

// import Navbar from './components/Navbar';
import Home from './components/Home';
import Customers from './components/Customers';
import Locations from './components/Locations';
import Clients from './components/Clients';
import AccessPoints from './components/AccessPoints';
import EventRecords from './components/EventRecords';
import Logs from './components/Logs';
import ClientLogs from './components/ClientLogs';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import APExtraInfo from './components/APExtraInfo';
import HubRelay from './components/HubRelay';
import KeypadCodes from './components/keypadcodes';
import ComPorts from './components/ComPorts';
import ReceptionCodes  from './components/ReceptionCodes';
import BarcodeReaders from './components/BarcodeReaders';
import OpenGateCodes from './components/OpenGateCodes';
import SupportLocations from './components/SupportLocation';
import SupportClients from './components/SupportClients';
import SupportTiles from './components/SupportTiles';
import SupportClientLogs from './components/SupportClientLogs';
import SupportLogs from './components/SupportLogs';
import SupportHubAndRelay from './components/SupportHubAndRelay';
import SupportCustomers from './components/SupportCustomer';
import ReplacementTiles from './components/ReplacementTiles';
import Projects from './components/Projects';
import Groups from './components/Groups';
import ClientStatusLogs from './components/ClientStatusLogs';
import Staffmembers from './components/Staffmembers';
import NotificationSettingsPage from './components/SupportNotifications';
import SupportAuditLogs from './components/SupportAuditLogs';
import SupportClientStatusLog from './components/SupportClientStatusLog';
import SupportLayout from './components/SupportLayout';
import SupportAccount from './components/SupportAccount';
import SupportResources from './components/SupportResources';
import SupportSettings from './components/SupportSettings';
import SupportMembers from './components/SupportMembers';
import AccessGate from './components/AccessGate';
import AdminUsers from './components/AdminUsers';
import AdminFeatures from './components/AdminFeatures';
import AdminCreateUser from './components/AdminCreateUser';
import AdminResources from './components/AdminResources';
import AdminResourceEditor from './components/AdminResourceEditor';
import AdminWalletSettings from './components/AdminWalletSettings';
import AdminActiveAccessBranding from './components/AdminActiveAccessBranding';
import AdminActiveAccessBrandingDetail from './components/AdminActiveAccessBrandingDetailPage';
import AdminCatalog from './components/AdminCatalog';
import AdminRoute from './components/AdminRoute';
import SupportWalletBranding from './components/SupportWalletBranding';
import SupportActiveAccessBranding from './components/SupportActiveAccessBranding';
import LocationWalletPortal from './components/LocationWalletPortal';
import StandaloneWalletPassPortal from './components/StandaloneWalletPassPortal';
import Unauthorized from './components/Unauthorized';
import InternalNavbar from './components/InternalNavbar';
import InternalResources from './components/InternalResources';
import InternalDownloads from './components/InternalDownloads';
import Members from './components/Members';
import SiteUserSupportRedirect from './components/SiteUserSupportRedirect';
import FlagManagement from './components/flags/FlagManagement';
import FlagAuditLog from './components/flags/FlagAuditLog';
import LocalUserManagement from './components/flags/LocalUserManagement';
import SiteViewer from './components/flags/SiteViewer';
import AdminFlagSystem from './components/flags/AdminFlagSystem';
import { FlagSystemRoute } from './components/flags/FlagSystemCommon';
import KonkrRoute from './components/konkr/KonkrRoute';
import { canReadAdminFlagSystemStatus } from './utils/flagSystemCapability';
import { useAuth } from './contexts/AuthContext';
import {
  canAccessInternalPages,
  canAccessCustomerWalletBranding,
  canAccessLocationWalletPortal,
  canAccessMembersManagement,
  canAccessNotificationSettings,
  resolvePostLoginPath,
} from './utils/accessControl';

const NotificationSettingsRoute = () => {
  return (
    <AccessGate
      canAccess={canAccessNotificationSettings}
      title="Notification Settings Unavailable"
      message="Your account does not have access to notification settings."
      actionLabel="Go To Support Settings"
      actionTo="/support/settings"
      autoRedirectTo="/support/settings"
      autoRedirectDelayMs={2500}
    >
      <NotificationSettingsPage />
    </AccessGate>
  );
};

const SupportMembersRoute = () => {
  return (
    <AccessGate
      canAccess={canAccessMembersManagement}
      title="Members Unavailable"
      message="Your account does not have access to members management."
      actionLabel="Go To Support Home"
      actionTo="/support"
      autoRedirectTo="/support"
      autoRedirectDelayMs={2500}
    >
      <SupportMembers />
    </AccessGate>
  );
};

const CustomerWalletBrandingRoute = () => (
  <AccessGate
    canAccess={canAccessCustomerWalletBranding}
    title="Wallet Settings Unavailable"
    message="Your account does not have access to Wallet Passes branding settings."
    actionLabel="Go To Support Home"
    actionTo="/support"
  >
    <SupportWalletBranding />
  </AccessGate>
);

const LocationWalletPortalRoute = () => (
  <AccessGate
    canAccess={canAccessLocationWalletPortal}
    title="Wallet Portal Unavailable"
    message="Your account does not have access to the Wallet Passes portal."
    actionLabel="Go To Support Home"
    actionTo="/support"
  >
    <LocationWalletPortal />
  </AccessGate>
);

const CustomerActiveAccessBrandingRoute = () => (
  <AccessGate
    canAccess={canAccessCustomerWalletBranding}
    title="Active Access Branding Unavailable"
    message="Your account does not have access to Active Access branding."
    actionLabel="Go To Support Home"
    actionTo="/support"
  >
    <SupportActiveAccessBranding />
  </AccessGate>
);

const InternalOnlyRoute = ({ children }) => {
  const { accessContext } = useAuth();

  return (
    <AccessGate
      canAccess={canAccessInternalPages}
      title="Internal Access Required"
      message="Your account does not have access to this internal area."
      actionLabel="Go To Home"
      actionTo={accessContext ? resolvePostLoginPath(accessContext) : '/'}
      autoRedirectTo={accessContext ? resolvePostLoginPath(accessContext) : '/'}
      autoRedirectDelayMs={2500}
    >
      {children}
    </AccessGate>
  );
};


const App = () => {
  // const [navbarItems, setNavbarItems] = useState([]);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [list, setList] = useState([]);

  const replaceHastPath = () => {
    const history = createBrowserHistory();
    const hash = history.location.hash;
    if(hash){
      const path = hash.replace(/^#/, '');
      if(path){
        history.replace(path);
      }
    }
  }

  replaceHastPath();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const fetchNavbarItems = async () => {
        try {
          // Replace this with the API call to fetch navbar items
          // const response = await axios.get('https://localhost:7263/api/Auth/profile', {
          //   headers: {
          //     Authorization: `Bearer ${token}`,
          //   },
          // });
          // setNavbarItems(response.data);
        } catch (error) {
          console.error('Error fetching navbar items:', error);
        }
      };

      fetchNavbarItems();
    }
  }, []);

  // const handleLoginSuccess = (data) => {
  //   setIsLoggedIn(true);
  //   setList(['Customers', 'Locations', 'Clients', 'Access Points']);
  // };

  const AppFrame = () => {
    const location = useLocation();
    const path = location.pathname || '';

    const hideInternalNavbar =
      path === '/login' ||
      path === '/forgot-password' ||
      path === '/reset-password' ||
      path === '/wallet-pass-portal' ||
      path.startsWith('/support') ||
      path === '/admin/unauthorized';

    return (
      <div className="App">
        {!hideInternalNavbar && <InternalNavbar />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/wallet-pass-portal" element={<StandaloneWalletPassPortal />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/locations/:customerName/:customerId" element={<Locations />} />
          <Route path="/clients/:type/:typeName/:typeId" element={<Clients />} />
          <Route path="/accesspoints/:type/:typeName/:typeId" element={<AccessPoints />} />
          <Route path="/events/:type/:typename/:id" element={<EventRecords />} />
          <Route path="/logs/:type/:typename/:id" element={<Logs />} />
          <Route path="/clientlogs/:type/:typename/:id" element={<ClientLogs />} />
          <Route
            path="/resources"
            element={
              <InternalOnlyRoute>
                <InternalResources />
              </InternalOnlyRoute>
            }
          />
          <Route
            path="/downloads"
            element={
              <InternalOnlyRoute>
                <InternalDownloads />
              </InternalOnlyRoute>
            }
          />
          <Route
            path="/members"
            element={
              <InternalOnlyRoute>
                <Members />
              </InternalOnlyRoute>
            }
          />
          <Route path="/auditlogs" element={<SupportAuditLogs />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/extra-info/:id' element={<APExtraInfo />} />
          <Route path='/hubrelay/:type/:apid' element={<HubRelay />} />
          <Route path='/keypadcodes/:locid' element={<KeypadCodes />} />
          <Route path='/comports/:clid' element={<ComPorts />} />
          <Route path='/receptioncodes/:locid' element={<ReceptionCodes />} />
          <Route path='/barcodereaders/:apid' element={<BarcodeReaders />} />
          <Route path='/opengatecodes/:locid' element={<OpenGateCodes />} />

          <Route path="/support" element={<SiteUserSupportRedirect><SupportLayout /></SiteUserSupportRedirect>}>
            <Route path="konkr" element={<Navigate to="/support/konkr/advertisers" replace />} />
            <Route path="konkr/advertisers" element={<KonkrRoute kind="advertisers" />} />
            <Route path="konkr/offers" element={<KonkrRoute kind="offers" />} />
            <Route path="flags" element={<FlagSystemRoute customerOnly><FlagManagement /></FlagSystemRoute>} />
            <Route path="flags/audit-log" element={<FlagSystemRoute customerOnly><FlagAuditLog /></FlagSystemRoute>} />
            <Route path="site-viewer" element={<FlagSystemRoute><SiteViewer /></FlagSystemRoute>} />
            <Route path="local-users" element={<FlagSystemRoute customerOnly><LocalUserManagement /></FlagSystemRoute>} />
            <Route index element={<SupportLocations />} />
            <Route path="sites" element={<SupportLocations />} />
            <Route path="clients" element={<SupportClients />} />
            <Route path="tiles" element={<SupportTiles />} />
            <Route path="clientlogs" element={<SupportClientLogs />} />
            <Route path="tilelogs" element={<SupportLogs />} />
            <Route path="hubrelay" element={<SupportHubAndRelay />} />
            <Route path="customers" element={<SupportCustomers />} />
            <Route path="notification-settings" element={<NotificationSettingsRoute />} />
            <Route path="auditlogs" element={<SupportAuditLogs />} />
            <Route path="clientstatuslogs" element={<SupportClientStatusLog />} />
            <Route path="account" element={<SupportAccount />} />
            <Route path="resources" element={<SupportResources />} />
            <Route path="settings" element={<SupportSettings />} />
            <Route path="members" element={<SupportMembersRoute />} />
            <Route path="wallet-branding" element={<CustomerWalletBrandingRoute />} />
            <Route path="active-access-branding" element={<CustomerActiveAccessBrandingRoute />} />
            <Route path="wallet" element={<LocationWalletPortalRoute />} />
          </Route>

          <Route path='/replacementtiles/:locationName/:locationId' element={<ReplacementTiles />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/groups/:typeId' element={<Groups />} />
          <Route path='/clientstatuslogs/:name/:id' element={<ClientStatusLogs />} />
          <Route path="/staffmembers/:type/:typeId" element={<Staffmembers />} />
          <Route path="/notification-settings" element={<NotificationSettingsRoute />} />
          <Route path="/admin/unauthorized" element={<Unauthorized />} />
          <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
          <Route path="/admin/users/create" element={<AdminRoute><AdminCreateUser /></AdminRoute>} />
          <Route path="/admin/features" element={<AdminRoute><AdminFeatures /></AdminRoute>} />
          <Route path="/admin/catalog" element={<AdminRoute><AdminCatalog /></AdminRoute>} />
          <Route path="/admin/resources" element={<AdminRoute><AdminResources /></AdminRoute>} />
          <Route path="/admin/resources/create" element={<AdminRoute><AdminResourceEditor /></AdminRoute>} />
          <Route path="/admin/resources/:id/edit" element={<AdminRoute><AdminResourceEditor /></AdminRoute>} />
          <Route path="/admin/customers/:customerId/wallet" element={<AdminRoute><AdminWalletSettings /></AdminRoute>} />
          <Route path="/admin/customers/:customerId/flags" element={<AccessGate canAccess={canReadAdminFlagSystemStatus}
            title="Admin Access Required" message="Your account does not have permission to view customer Flag System status."
            actionLabel="Go To Home" actionTo="/"><AdminFlagSystem /></AccessGate>} />
          <Route path="/admin/active-access-branding" element={<AdminRoute><AdminActiveAccessBranding /></AdminRoute>} />
          <Route path="/admin/active-access-branding/:customerId" element={<AdminRoute><AdminActiveAccessBrandingDetail /></AdminRoute>} />
          {/* Add more routes as needed */}
        </Routes>
      </div>
    );
  };

  return (
    <BrowserRouter>
      <AppFrame />
    </BrowserRouter>
  );
};

export default App;
